<template>
  <div>
    <v-text-field
      v-model="analysis.name"
      label="Name"
      outlined
    />

    <v-select
      v-model="analysis.chartType"
      label="Chart Type"
      :items="allChartTypes"
      outlined
      @input="onChangeChartType"
    >
      <template v-slot:item="{ attrs, item, on }">
        <v-list-item
          v-bind="attrs"
          v-on="on"
        >
          <v-list-item-icon>
            <v-icon
              :style="{ transform: `rotate(${item.rotate || 0}deg)` }"
            >
              {{ item.icon }}
            </v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            {{ item.text }}
          </v-list-item-content>
        </v-list-item>
      </template>

      <template v-slot:selection="{ attrs, item }">
        <v-icon
          class="mr-1"
          :style="{ transform: `rotate(${item.rotate || 0}deg)` }"
        >
          {{ item.icon }}
        </v-icon>

        <span>{{ item.text }}</span>
      </template>
    </v-select>

    <v-select
      v-model="analysis.model"
      label="Data Source"
      :items="allModels"
      outlined
      @input="onChangeModel"
    >
      <template v-slot:item="{ attrs, item }">
        <v-list-item
          v-bind="attrs"
          v-on="on"
        >
          <v-list-item-icon>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            {{ item.text }}
          </v-list-item-content>
        </v-list-item>
      </template>

      <template v-slot:selection="{ attrs, item }">
        <v-icon class="mr-1">
          {{ item.icon }}
        </v-icon>

        <span>{{ item.text }}</span>
      </template>
    </v-select>

    <v-row>
      <v-col cols="6">
        <v-select
          v-model="rows"
          label="Rows"
          :items="allModelProps"
          outlined
          clearable
          :disabled="!analysis.model"
          @change="onChangePivot()"
        />
      </v-col>

      <v-col cols="6">
        <v-select
          v-model="columns"
          label="Columns"
          :items="allModelProps"
          outlined
          clearable
          :disabled="!analysis.model"
          @change="onChangePivot()"
        />
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="6">
        <v-select
          v-model="values"
          label="Values"
          :items="allModelProps"
          outlined
          :disabled="!analysis.model"
          @change="onChangePivot()"
        />
      </v-col>

      <v-col cols="6">
        <v-select
          v-model="aggregation"
          label="Aggregation"
          :items="allAggregations"
          outlined
          :disabled="!analysis.model"
          @change="onChangePivot()"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import aggregators from './aggregators'
import Activity from '@/models/Activity'
import Expense from '@/models/Expense'
import Resource from '@/models/Resource'

export default {
  props: {
    analysis: {
      type: Object,
      default: () => { return {} }
    }
  },
  data () {
    return {
      allAggregations: Object.keys(aggregators),
      allChartTypes: [
        { text: 'Area', value: 'area', icon: 'landscape' },
        { text: 'Bar', value: 'bar', icon: 'bar_chart', rotate: 90 },
        { text: 'Bubble', value: 'bubble', icon: 'bubble_chart' },
        { text: 'Column', value: 'column', icon: 'bar_chart' },
        { text: 'Line', value: 'line', icon: 'show_chart' },
        { text: 'Pie', value: 'pie', icon: 'pie_chart' },
        { text: 'Radar', value: 'radar', icon: 'signal_wifi_4_bar' },
        { text: 'Radial Bar', value: 'radialBar', icon: 'wifi_tethering', rotate: 135 },
        { text: 'Scatter', value: 'scatter', icon: 'scatter_plot' }
      ],
      allModels: [
        { text: 'Activities', value: 'activities', icon: 'assignment', model: Activity },
        { text: 'Expenses', value: 'expenses', icon: 'attach_money', model: Expense },
        { text: 'Resources', value: 'resources', icon: 'group', model: Resource }
      ],
      allModelProps: [],

      // pivot report
      rows: null,
      columns: null,
      values: null,
      aggregation: null
    }
  },
  mounted () {
    if (this.analysis.report) {
      const slice = this.analysis.report.slice

      this.rows = slice.rows[0].uniqueName
      this.columns = slice.columns[0].uniqueName
      this.values = slice.measures[0].uniqueName
      this.aggregation = slice.measures[0].aggregation
    }

    this.onChangeModel()
  },
  methods: {
    onChangeChartType () {
      this.$emit('change:chart')
    },
    onChangePivot () {
      this.analysis.report = {
        slice: {
          rows: [],
          columns: [],
          measures: []
        }
      }

      if (this.rows) {
        this.analysis.report.slice.rows.push({ uniqueName: this.rows })
      }

      if (this.columns) {
        this.analysis.report.slice.columns.push({ uniqueName: this.columns })
      }

      if (this.values && this.aggregation) {
        this.analysis.report.slice.measures.push({ uniqueName: this.values, aggregation: this.aggregation })
      }

      this.$emit('change:pivot')
    },
    onChangeModel () {
      if (!this.analysis.model) { return }

      const model = this.allModels.find(m => m.value === this.analysis.model)
      if (model && model.model) {
        const Klass = model.model
        this.allModelProps = []

        for (const attr of Object.keys(new Klass().attributes)) {
          if (attr.toLowerCase().includes('date')) {
            this.allModelProps.push(`${attr}.Year`)
            this.allModelProps.push(`${attr}.Month`)
            this.allModelProps.push(`${attr}.Day`)
          } else {
            this.allModelProps.push(attr)
          }
        }

        this.$emit('change:model')
      }
    }
  }
}
</script>
